import React, { useState } from 'react';
import { Line } from '../types';

interface LineManagerProps {
  lines: Line[];
  onLinesUpdate: (lines: Line[]) => void;
  selectedHeaderToOrg?: string;
}

export const useLineManager = ({ lines, onLinesUpdate, selectedHeaderToOrg }: LineManagerProps) => {
  const [newRowIds, setNewRowIds] = useState<Set<string>>(new Set());

  const addNewRow = () => {
    const newRowId = `new-${Date.now()}`;
    const newRow: Line = {
      id: newRowId,
      description: '',
      serialNumber: '',
      assetNumber: '',
      validatedSerialNumber: '',
      validatedAssetNumber: '',
      itemNumber: '',
      toSubinventory: '',
      toLocator: '',
      isSerialValid: false,
      validatedSerialItem: '',
      validatedSerialSite: '',
      status: ''
    };
    
    onLinesUpdate([newRow, ...lines]);
    setNewRowIds(prev => {
      const newSet = new Set(prev);
      newSet.add(newRowId);
      return newSet;
    });
  };

  const updateLine = (lineId: string, field: string, value: string) => {
    console.log('updateLine called:', { lineId, field, value });
    
    const fieldMap: Record<string, keyof Line> = {
      'Validated Serial Number': 'validatedSerialNumber',
      'Validated Asset Number': 'validatedAssetNumber',
      'To Subinventory': 'toSubinventory',
      'To Locator': 'toLocator',
      'Validated Serial Item': 'validatedSerialItem'
    };

    const updatedLines = lines.map(line => {
      if (line.id === lineId) {
        const updatedLine = { ...line, [fieldMap[field]]: value };
        console.log('Updating line:', line.id, 'field:', field, 'new value:', value);
        return updatedLine;
      }
      return line;
    });
    
    console.log('Updated lines:', updatedLines);
    onLinesUpdate(updatedLines);
  };

  const cancelChanges = () => {
    // Remove new rows and revert to original state
    const originalLines = lines.filter(line => !newRowIds.has(line.id));
    onLinesUpdate([]);
    setNewRowIds(new Set());
  };

  const clearNewRowIds = () => {
    setNewRowIds(new Set());
  };

  return {
    addNewRow,
    updateLine,
    cancelChanges,
    clearNewRowIds,
    newRowIds
  };
};